import { render, staticRenderFns } from "./safe.vue?vue&type=template&id=5318c47d&scoped=true"
import script from "./safe.vue?vue&type=script&lang=js"
export * from "./safe.vue?vue&type=script&lang=js"
import style0 from "./safe.vue?vue&type=style&index=0&id=5318c47d&prod&scoped=true&lang=css"
import style1 from "./safe.vue?vue&type=style&index=1&id=5318c47d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5318c47d",
  null
  
)

export default component.exports